import { isBlank as valueIsBlank, isEmpty as valueIsEmpty } from './values';

/**
 * Determine if a value is an empty string, array, object or falsy.
 * @param value Value to check.
 *
 * @returns True if the value is empty.
 */
export function isBlank<T>(value: T | T[]): boolean {
  // moved implementation to values.ts
  return valueIsBlank(value);
}

/**
 * Determine if a value is an empty string, array, object.
 * @param value Value to check.
 *
 * @returns True if the value is empty.
 */
export function isEmpty<T>(value: T | T[]): boolean {
  // moved implementation to values.ts
  return valueIsEmpty(value);
}
